import React, { useContext, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { Container } from '../../../base/Container'
import AppToaster from '../../../commonLib/AppToaster'
import { loadingMiniContext } from '../../../commonLib/lodingMiniContext'
import { TimelineHistory } from '../../Global/TimelineHistory'
import *as productReturnCrud from '../../../_crud/productReturnCrud'
import { ProductReturnItemView } from './ProductReturnItemView'
import { loadingContext } from '../../../commonLib/_lodingContext'

export function ProductReturnDashBoard() {
    const [isLoadingMini, setIsLoadingMini] = useContext(loadingMiniContext)
    const [isLoading, setIsLoading] = useContext(loadingContext)
    const [productReturn, setProductReturn] = useState()
    const { id } = useParams()

    function doRefresh() {
        getData()
    }

    useEffect(() => {
        getData()
    }, []);


    function getData() {
        setIsLoading(true);
        setIsLoadingMini(true);
        productReturnCrud.GetById(id)
            .then(res => {
                if (res.data.data) {
                    if (res.data.result.succeeded) {
                        let hdata = res.data.data
                        setProductReturn(hdata);
                        setIsLoading(false)
                        setIsLoadingMini(false)
                    }
                    else {
                        setIsLoading(false)
                        setIsLoadingMini(false)
                        setProductReturn([]);
                    }
                }
                else {
                    setIsLoading(false)
                    setIsLoadingMini(false)
                    setProductReturn([]);
                    AppToaster("Server Error /Invalid Try.", 'error')
                }
            })
            .catch(error => {
                setIsLoading(false);
                setIsLoadingMini(false);
                AppToaster(error, 'error')
            })
    }
    return (
        <Container title="Product Return Dashboard" doRefresh={doRefresh} isBack="true" >

            <div className="row">
                <div className="col-lg-8">
                <ProductReturnItemView productReturn={productReturn} />
                </div>
                <div className="col-lg-4">
                    <TimelineHistory id={id} type={8} pageSize={10} text="Product Return Timeline" />
                </div>

            </div>
        </Container >
    )
}

